import React, { memo, useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'
import Skeleton from '@material-ui/lab/Skeleton'
import ApexCharts from 'apexcharts'

import * as optionsChart from './chartOptions'

import { equal } from 'utils/memoEqual'

const ChartArea = ({
  seriesY = [],
  categoriesX = [],
  className = '',
  id = '',
  isFetching = true,
}) => {
  const calculatedParams = seriesY?.reduce(
    (res, series) => {
      if (series.type === 'line') {
        res.yaxis = [
          res.yaxis,
          {
            ...optionsChart.yaxisTemperature,
            max: Math.max(...series.data) * 1.2,
          },
        ]
        res.fillTypes = [res.fillTypes, 'solid']
      }

      res.markersColors.push(series.color)

      return res
    },
    {
      yaxis: optionsChart.yaxis,
      fillTypes: 'gradient',
      markersColors: [],
    }
  )

  const options = {
    ...optionsChart,
    xaxis: {
      ...optionsChart.xaxis,
      categories: categoriesX,
    },
    yaxis: calculatedParams.yaxis,
    fill: {
      ...optionsChart.fill,
      type: calculatedParams.fillTypes,
    },
    chart: {
      ...optionsChart.chart,
      offsetX: 0,
      id,
    },
    markers: {
      ...optionsChart.markers,
      strokeColors: calculatedParams.markersColors,
    },
  }

  useEffect(() => {
    if (seriesY?.length) {
      ApexCharts.exec(id, 'updateOptions', options)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoriesX, seriesY])

  const { width, height } =
    document
      .getElementsByClassName('apexcharts-grid')[0]
      ?.getBoundingClientRect() || {}

  return (
    <div className={`chart_area_container ${className}`}>
      <ReactApexChart
        options={options}
        series={seriesY}
        height={373}
        width={'100%'}
      />

      {isFetching && (
        <div
          className="backdrop"
          style={{ height: `${height}px`, width: `${width + 1}px` }}
        >
          <Skeleton
            variant="rect"
            className="chart_area_skeleton"
            height={height}
            width={width}
          />
        </div>
      )}
    </div>
  )
}

export default memo(ChartArea, equal)
